import { makeStyles } from "@material-ui/styles"

export const useBlankBorderStyle = makeStyles((theme) => ({
  blankBorder: {
    borderColor: theme.props.primary.lighter,
    backgroundColor: theme.props.primary.lightest,
  },
}));
